import type { Entry } from 'contentful';

import type { Nullable } from '@libs/core';

export const useEntryHyperlink = (entry: Entry): Nullable<{ href: string }> => {
    // Get contentType Id to check if it's a page
    const { id } = entry?.sys?.contentType?.sys || {};
    // Get page id to link to since we use pageId for URL
    const { pageId } = entry?.fields || {};

    // If content type id is not page, return null
    // As we don't want to link to other type of contentful content.
    if (!id.toLowerCase().includes('page')) {
        return null;
    }

    return {
        // TODO: review if this needs to be changed
        href: `/${pageId}`,
    };
};
